module.exports = kolibriGlobal.utils.CatchErrors;